import React, { useEffect, useState } from "react";
import { Container, Card, Spinner, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { getInvoice, sendInvoice } from "../../store/slices/booking";

export default function InvoicePreview() {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    fetchInvoice();
  }, [id]);

  const fetchInvoice = async () => {
    try {
      setLoading(true);

      const res = await dispatch(
        getInvoice({ id })
      ).unwrap();

      setInvoice(res.data);
    } catch (err) {
      toast.error("Failed to load invoice");
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async () => {
    try {
      setSending(true);

      await dispatch(
        sendInvoice({
          id,
        })
      ).unwrap();

      toast.success("Invoice sent successfully");

      navigate(-1);
    } catch (err) {
      toast.error("Failed to send invoice");
    } finally {
      setSending(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (!invoice) {
    return (
      <Container className="text-center mt-5">
        Invoice not found
      </Container>
    );
  }

  return (
    <Container>
      <Card className="p-4 mt-3 shadow-sm">

        <h4 className="mb-4">
          Invoice Preview
        </h4>

        <Row>

          <Col md={5}>

            <p>
              <strong>
                Invoice Number:
              </strong>{" "}
              {invoice.invoiceNumber}
            </p>

            <p>
              <strong>
                Invoice Type:
              </strong>{" "}
              {invoice.invoiceType}
            </p>

            <p>
              <strong>
                Customer:
              </strong>{" "}
              {invoice.booking?.lead?.name}
            </p>

            <p>
              <strong>
                Phone:
              </strong>{" "}
              {invoice.booking?.lead?.phone}
            </p>

            <p>
              <strong>
                Total:
              </strong>{" "}
              ₹{invoice.totalAmount}
            </p>

            <p>
              <strong>
                Paid:
              </strong>{" "}
              ₹{invoice.amountPaid}
            </p>

            <p>
              <strong>
                Balance:
              </strong>{" "}
              ₹{invoice.balanceAmount}
            </p>

          </Col>

          <Col md={7}>

            {!invoice.pdfUrl ? (
              <div className="text-center p-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <iframe
                src={invoice.pdfUrl}
                title="Invoice PDF"
                width="100%"
                height="650"
                style={{
                  border: "1px solid #ddd",
                  borderRadius: 8,
                }}
              />
            )}

          </Col>

        </Row>

        <div className="d-flex justify-content-center gap-3 mt-4">

          <button
            className="submit-btn"
            onClick={handleSend}
            disabled={sending}
          >
            {sending
              ? "Sending..."
              : "Send to Customer"}
          </button>

          <a
            href={invoice.pdfUrl}
            target="_blank"
            rel="noreferrer"
          >
            <button className="submit-btn">
              Download PDF
            </button>
          </a>

          <button
            className="submit-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>

        </div>

      </Card>
    </Container>
  );
}